import { render } from "./ChargerDetail.vue?vue&type=template&id=52851da8"
import script from "./ChargerDetail.vue?vue&type=script&lang=js"
export * from "./ChargerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__